<template>
<div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'PrintTypeList' }">Print Types</el-breadcrumb-item>
            <el-breadcrumb-item>Add</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form
        ref="print_type"
        :rules="rules.print_type"
        :model="print_type"
        :label-position="label_position">

        <el-form-item label="Name" prop="name">
            <el-input v-model="print_type.name"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="addPrintType('print_type')">Add Print Type</el-button>
        </el-form-item>

   </el-form>

  <pre v-if="config.debug">{{$data}}</pre>

   
</div>
</template>

<style>

</style>

<script>

    import Config from '@/store/Config.js';

    export default {
        data: function() {
            return {
                config: Config.config,
                page_alias: 'Add Print Type',
                page_slug: 'add-print-type',
                label_position: 'top',
                loading: false,
                rules: {
                    print_type: {
                        name: [
                            {required: true, message: 'Please Enter Name', trigger: 'blur'}
                        ]
                    }
                },

                print_type: {
                    name: '',
                }
            };
        },

        mounted: function() {
            const me = this;
        },

        methods: {

            addPrintType: function(formName) {
                console.log('Add Print Type Function');
                const me = this;
                me.$refs[formName].validate((valid) => {
                if (valid) {
                    me.$http.post(me.config.api + 'printType', me.print_type).then(
                        response => {
                        console.log('Success posting data')  
                        console.log(response.status);
                        console.log(response.statusText);
                        // Success notification 
                        me.$notify({
                            title: 'Success',
                            message: 'The Print Type Was Added',
                            type: 'success'
                        });
                        // Reset the form to prevent double submissions 
                        me.resetForm('print_type');
                        // Redirect to the list page
                        me.$router.push({ name: 'PrintTypeList'});
                        }, response => {
                            console.log('Error posting data');
                            console.log(response.status);
                            console.log(response.statusText);
                        }
                    );
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });
            },

            resetForm(formName) {
                const me = this;
                this.$refs[formName].resetFields();
            }


        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/print-types/PrintTypeAdd.vue